/* import countriesApi from "../../api/countries" */
import utilsApi from "../../api/utils"

// general state for the eCommerce
const state = {
  countries: [],
  fetched: false,
  error: false,
  dataShape: [],
  navStyle: {
    height: "50px",
    backgroundColor: "transparent",
    color: "white",
    boxShadow: "none",
  },
  alertStyle: {
    backgroundColor: "#f62590",
    color: "white",
    height: "0px",
    fontSize: "0.7rem",
    fontWeight: 600,
    overflow: "hidden",
  },
  colorScheme: {
    accent: "#665dc3",
    alert: "#f62590",
    dark: "#424242",
  },
  activeAlert: {
    type: "white-ref",
    title: "Ohh noooo",
    message: "Algo anda mal aqui llamame ;)",
    classes: "bg-white",
    status: false,
    to: {
      path: "/",
      query: null,
    },
  },
  activeMenus: {
    isAccountMenu: false,
    isPauseMenu: false,
    isProfileMenu: false,
    isProfileSubMenu: false,
    isDeleteProfileMenu: false,
    isDeleteAccountMenu: false,
  },
  isLoading: false,
  modalPlaceHolder: false,
}

const getters = {
  countries: state => state.countries,
  fetched: state => state.fetched,
  countriesError: state => state.error,
  countries_dataShape: state => state.dataShape,
  navStyle: state => state.navStyle,
  alertStyle: state => state.alertStyle,
  colorScheme: state => state.colorScheme,
  isLoading: state => state.isLoading,
  activeAlert: state => state.activeAlert,
  activeMenus: state => state.activeMenus,
  modalPlaceHolder: state => state.modalPlaceHolder,
}
const actions = {
  async FETCH_countries({ commit }) {
    let apiResponse = await utilsApi.getObjects("countries")
    console.log("apiResponse", apiResponse)
    if (apiResponse != null) {
      commit("GENERAL_SETTING", apiResponse)
    } else {
      commit("GENERAL_ERROR")
    }
  },

  SET_NAVSTYLE({ commit }, style) {
    commit("SET_NAVSTYLE", style)
  },
  SET_ALERTSTYLE({ commit }, style) {
    commit("SET_ALERTSTYLE", style)
  },
  SET_GENERAL_ERROR({ commit }, error) {
    commit("SET_GENERAL_ERROR", error)
  },
  SET_IS_LOADING({ commit }, status) {
    commit("SET_IS_LOADING", status)
  },
  SET_ACTIVE_ALERT({ commit }, status) {
    commit("SET_ACTIVE_ALERT", status)
    return true
  },
  TOGGLE_ACTIVE_ALERT({ commit, state }) {
    commit("SET_ACTIVE_ALERT", {
      ...state.activeAlert,
      status: !state.activeAlert.status,
    })
    return true
  },
  SET_ACTIVE_MENUS({ commit }, body) {
    commit("SET_ACTIVE_MENUS", body)
    return true
  },
  SET_MODAL_PLACEHOLDER({ commit }, body) {
    commit("SET_MODAL_PLACEHOLDER", body)
    return true
  },
  TOGGLE_MODAL_PLACEHOLDER({ commit, state }) {
    commit("SET_MODAL_PLACEHOLDER", !state.modalPlaceHolder)
    return true
  },
}
const mutations = {
  GENERAL_SETTING: (state, { countries, dataShape }) => {
    console.log(state)
    state.countries = countries
    state.dataShape = dataShape
    state.fetched = true
    state.error = false
  },
  SET_GENERAL_ERROR: (state, error) => {
    state.fetched = true
    state.dataShape = []
    state.error = error
  },
  GENERAL_ERROR: state => {
    state.countries = null
    state.fetched = true
    state.dataShape = []
    state.error = false
  },
  SET_NAVSTYLE: (state, style) => {
    state.navStyle = style
  },
  SET_ALERTSTYLE: (state, style) => {
    state.alertStyle = style
  },
  SET_IS_LOADING: (state, status) => {
    state.isLoading = status
  },
  SET_ACTIVE_ALERT: (state, status) => {
    state.activeAlert = status
  },
  SET_ACTIVE_MENUS: (state, status) => {
    state.activeMenus = status
  },
  SET_MODAL_PLACEHOLDER: (state, status) => {
    state.modalPlaceHolder = status
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}
